import React, { PureComponent, ReactNode, Suspense } from "react";
import styled from "styled-components";

import { Page, PageCMSLoader } from "../../components";
import {
  ICMSId,
  ICMSType,
} from "../../components/CMSLoader/PageCMSLoader/PageCMSLoader.component";
import theme from "../../theme";

import { IPrismicPage } from "./PageCmsCustom/types";

export interface IRouteParams {
  cmsId: ICMSId;
  cmsType: ICMSType;
}

// tslint:disable-next-line: no-empty-interface
export interface IProps extends IPrismicPage {}

const PageCMS = styled(Page)`
  overflow-x: hidden;
`;

type ITemplateType = "makingWhisky" | "default";

interface IResponsiveGrid {
  templateType?: ITemplateType;
}

const ResponsiveGrid = styled.div<IResponsiveGrid>`
  /* Styles for CMS pages "elaboration du whisky" */
  ${({ templateType }: IResponsiveGrid): string | null =>
    templateType === "makingWhisky"
      ? `
        img {
          float: none !important;
          margin: 15px 0 !important;
        }
        .pager {
          position: relative;
          border-top: 1px solid #C3BBB9;
          float: none !important;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          margin: 0 auto !important;
        }
        .pager ul {
          overflow-x: auto;
          display: flex;
          justify-content: center;
          width: 100%;
        }
        .pager .prev, .pager .next {
          order: 1;
        }
        .pager ul li {
          padding: 10px;
        }
        `
      : null}
`;

const TemplateTypeSelector = (cmsId: string): ITemplateType =>
  ((cmsId.startsWith("elaboration-du-whisky") ||
    cmsId.startsWith("en___making-whisky")) &&
    "makingWhisky") ||
  "default";

interface IState {
  tabTitle: string | null;
}

export default class CMS extends PureComponent<IProps> {
  public state: IState = {
    tabTitle: null,
  };
  public render(): ReactNode {
    const { cmsId, cmsType, data } = this.props;

    return (
      <PageCMS
        id="page-wrap"
        backgroundColor={theme.colors.white}
        tabTitle={this.state.tabTitle}
        horizontalPadding={0}
      >
        <div className="lmdw-styles">
          <ResponsiveGrid
            className={`responsive-grid cms-page-view cms-${cmsId}`}
            templateType={TemplateTypeSelector(cmsId)}
          >
            <Suspense fallback={<div />}>
              <PageCMSLoader
                id={cmsId}
                type={cmsType}
                data={data}
                setTabTitle={(tabTitle: string | null): void =>
                  this.setState({ tabTitle })
                }
              />
            </Suspense>
          </ResponsiveGrid>
        </div>
      </PageCMS>
    );
  }
}
